import React from 'react';
import { motion } from 'framer-motion';
import { FiTool, FiSettings, FiGlobe } from 'react-icons/fi';

const Services = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Under Construction Hero */}
      <section className="relative h-screen flex items-center justify-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(23, 33, 74, 0.8), rgba(23, 33, 74, 0.8)), url('https://images.unsplash.com/photo-1541510549862-50ded4acbde8?q=80&w=1738&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`
          }}
        />
        
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <motion.div
              className="text-6xl mb-4"
              animate={{ rotate: [0, 5, -5, 0] }}
              transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
            >
              🚧
            </motion.div>
            
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Projects Page
              <span className="block text-aero-blue text-3xl md:text-4xl mt-2">
                Under Construction
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
              We're building something amazing for you.   From remote helicopter overhauls to complete logistical relocations, 
              our work spans continents and specialties. Every operation is executed 
              with precision, safety, and efficiency.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              <motion.div
                className="bg-midnight-navy/60 backdrop-blur-md p-6 rounded-lg border border-aero-blue/30"
                whileHover={{ scale: 1.05, backgroundColor: 'rgba(159, 203, 220, 0.1)' }}
                transition={{ duration: 0.3 }}
              >
                <FiSettings className="text-aero-blue text-3xl mb-3 mx-auto" />
                 <h3 className="text-lg font-semibold mb-2">Global Reach</h3>
                <p className="text-gray-300 text-sm">Aircraft operations completed across 5+ nations</p>
              </motion.div>

              <motion.div
                className="bg-midnight-navy/60 backdrop-blur-md p-6 rounded-lg border border-aero-blue/30"
                whileHover={{ scale: 1.05, backgroundColor: 'rgba(159, 203, 220, 0.1)' }}
                transition={{ duration: 0.3 }}
              >
                <FiTool className="text-aero-blue text-3xl mb-3 mx-auto" />
                  <h3 className="text-lg font-semibold mb-2">On-Time Execution</h3>
                <p className="text-gray-300 text-sm">Fast turnarounds on time-sensitive operations</p>
              </motion.div>

              <motion.div
                className="bg-midnight-navy/60 backdrop-blur-md p-6 rounded-lg border border-aero-blue/30"
                whileHover={{ scale: 1.05, backgroundColor: 'rgba(159, 203, 220, 0.1)' }}
                transition={{ duration: 0.3 }}
              >
                <FiGlobe className="text-aero-blue text-3xl mb-3 mx-auto" />
             <h3 className="text-lg font-semibold mb-2">Verified Results</h3>
                <p className="text-gray-300 text-sm">Documented safety and compliance in every phase</p>
              </motion.div>
            </div>

            <motion.button
              className="mt-8 bg-aero-blue text-midnight-navy px-8 py-3 rounded-lg font-medium hover:bg-aero-blue/90 transition-colors duration-200"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Contact Us for Details
            </motion.button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Services;